<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 428.3 439.6" style="enable-background:new 0 0 428.3 439.6;" xml:space="preserve">
    <g>
      <text data-ignore transform="matrix(1 0 0 1 366.085 240.9724)" class="st1 st2 st3">DESIGN</text>
      <g id="XMLID_1001_">
        <g>
          <polygon data-ignore class="st4" points="418.5,158.3 371.6,205.2 356.6,210.7 361.9,195.4 416.1,141.2 425.9,151 			"/>
          <polygon data-ignore class="st5" points="407.6,182.1 425.4,199.9 425.4,199.9 416.9,191.4 407.6,182.1 			"/>
          <polygon data-ignore class="st6" points="416.9,191.4 425.4,199.9 415.6,209.6 397.9,191.9 397.9,191.9 402.7,187 407.6,182.1 			"/>
          <polygon data-ignore class="st5" points="366.9,141.4 385,159.5 385,159.5 375.8,150.4 366.9,141.4 			"/>
          <polygon data-ignore class="st6" points="375.8,150.4 385,159.5 375.2,169.2 357.1,151.1 357.1,151.1 366.9,141.4 			"/>
        </g>
        <polygon data-ignore class="st6" points="371.6,205.2 356.6,210.7 361.9,195.4 		"/>
        <g>
          <rect data-ignore x="412.1" y="142.9" transform="matrix(0.7071 -0.7071 0.7071 0.7071 16.3295 338.9512)" class="st6" width="10.3" height="13.8"/>
          <line data-ignore class="st7" x1="408.8" y1="148.5" x2="361.9" y2="195.4"/>
          <polyline data-ignore class="st7" points="366.8,200.3 371.6,205.2 418.5,158.3 			"/>
          <polyline data-ignore class="st7" points="382.1,162.4 385,159.5 385,159.5 375.8,150.4 366.9,141.4 366.7,141.2 357,151 375.2,169.2 			"/>
          <polyline data-ignore class="st7" points="402.7,187 407.6,182.1 416.9,191.4 425.4,199.9 415.6,209.6 415.6,209.6 397.9,191.9 			"/>
          <line data-ignore class="st7" x1="371" y1="155.2" x2="375.8" y2="150.4"/>
          <line data-ignore class="st7" x1="413.5" y1="194.8" x2="416.9" y2="191.4"/>
        </g>
        <g>
          <polyline data-ignore class="st7" points="366.8,200.3 371.6,205.2 418.5,158.3 425.9,151 416.1,141.2 361.9,195.4 			"/>
          <polyline data-ignore class="st7" points="382.1,162.4 385,159.5 385,159.5 375.8,150.4 366.9,141.4 366.7,141.2 357,151 375.2,169.2 			"/>
          <polyline data-ignore class="st7" points="402.7,187 407.6,182.1 416.9,191.4 425.4,199.9 415.6,209.6 415.6,209.6 397.9,191.9 			"/>
          <line data-ignore class="st7" x1="361.9" y1="195.4" x2="356.6" y2="210.7"/>
          <line data-ignore class="st7" x1="371.6" y1="205.2" x2="356.6" y2="210.7"/>
          <line data-ignore class="st7" x1="413.7" y1="153.4" x2="418.5" y2="158.3"/>
          <line data-ignore class="st7" x1="371" y1="155.2" x2="375.8" y2="150.4"/>
          <line data-ignore class="st7" x1="413.5" y1="194.8" x2="416.9" y2="191.4"/>
        </g>
      </g>
    </g>
    <g>
      <text data-ignore transform="matrix(1 0 0 1 102.8424 438.4804)" class="st1 st2 st3">TESTING</text>
      <g>
        <circle data-ignore class="st4" cx="103.3" cy="402.5" r="5.6"/>
        <circle data-ignore class="st4" cx="103.3" cy="381.1" r="5.6"/>
        <circle data-ignore class="st4" cx="103.3" cy="359.7" r="5.6"/>
        <line data-ignore class="st7" x1="124.6" y1="361.2" x2="163.8" y2="361.2"/>
        <line data-ignore class="st7" x1="124.6" y1="381.2" x2="156.7" y2="381.2"/>
        <line data-ignore class="st7" x1="124.6" y1="402.6" x2="163.8" y2="402.6"/>
        <path data-ignore class="st7" d="M108.9,359.8c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6"/>
        <path data-ignore class="st7" d="M108.9,381.2c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6"/>
        <path data-ignore class="st7" d="M108.9,402.6c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6"/>
      </g>
    </g>
    <g>
      <text data-ignore transform="matrix(1 0 0 1 276.5513 438.4804)" class="st1 st2 st3">PROTOTYPING</text>
      <g>
        <circle data-ignore class="st6" cx="323.8" cy="341.6" r="5.6"/>
        <path data-ignore class="st7" d="M329.4,341.6c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6"/>
        <line data-ignore class="st7" x1="323.8" y1="347.2" x2="295.5" y2="402.3"/>
        <line data-ignore class="st7" x1="323.8" y1="347.2" x2="352.1" y2="402.3"/>
        <line data-ignore class="st7" x1="295.5" y1="402.3" x2="297.3" y2="408.2"/>
        <line data-ignore class="st7" x1="352.1" y1="402.3" x2="350.3" y2="408.2"/>
        <line data-ignore class="st7" x1="323.8" y1="374.1" x2="352.1" y2="374.1"/>
        <line data-ignore class="st7" x1="295.5" y1="374.1" x2="310" y2="374.1"/>
      </g>
    </g>
    <g>
      <text data-ignore transform="matrix(1.0308 0 0 1 0.4263 241.0776)" class="st1 st2 st8">PRODUCTION</text>
      <g>
        <g>
          <path data-ignore class="st4" d="M52.2,181.6c-0.6,3-1.8,5.8-3.4,8.3c-0.8-0.5-1.8-0.8-2.9-0.8c-3.1,0-5.6,2.5-5.6,5.6c0,1.1,0.3,2,0.8,2.9
            c-2.5,1.6-5.3,2.8-8.3,3.4c-0.6-2.4-2.8-4.2-5.4-4.2s-4.8,1.8-5.4,4.2c-3-0.6-5.8-1.8-8.3-3.4c0.5-0.8,0.8-1.8,0.8-2.9
            c0-3.1-2.5-5.6-5.6-5.6c-1,0-2,0.3-2.8,0.8c-1.6-2.5-2.8-5.3-3.4-8.3c2.4-0.6,4.2-2.8,4.2-5.4c0-2.6-1.8-4.8-4.2-5.4
            c0.6-3,1.8-5.8,3.4-8.3c0.8,0.5,1.8,0.8,2.8,0.8c3.1,0,5.6-2.5,5.6-5.6c0-1-0.3-2-0.8-2.9c2.5-1.6,5.3-2.8,8.3-3.4
            c0.6,2.4,2.8,4.2,5.4,4.2s4.8-1.8,5.4-4.2c3,0.6,5.8,1.8,8.3,3.4c-0.5,0.8-0.8,1.8-0.8,2.9c0,3.1,2.5,5.6,5.6,5.6
            c1,0,2-0.3,2.9-0.8c1.6,2.5,2.8,5.3,3.4,8.3c-2.4,0.6-4.2,2.8-4.2,5.4C48,178.8,49.8,181,52.2,181.6z"/>
        </g>
        <circle data-ignore class="st6" cx="81.5" cy="156" r="5.6"/>
        <circle data-ignore class="st6" cx="64.4" cy="194.5" r="5.6"/>
        <circle data-ignore class="st6" cx="27.4" cy="176.2" r="5.6"/>
        <g>
          <path data-ignore class="st7" d="M22,151.2c-3,0.6-5.8,1.8-8.3,3.4"/>
          <path data-ignore class="st7" d="M52.2,170.6c-0.6-3-1.8-5.8-3.4-8.3"/>
          <path data-ignore class="st7" d="M41.1,197.4c-2.5,1.6-5.3,2.8-8.3,3.4"/>
          <path data-ignore class="st7" d="M6.1,189.7c-1.6-2.5-2.8-5.3-3.4-8.3"/>
          <path data-ignore class="st7" d="M6.1,162.4c-1.6,2.5-2.8,5.3-3.4,8.3"/>
          <path data-ignore class="st7" d="M22,200.8c-3-0.6-5.8-1.8-8.3-3.4"/>
          <path data-ignore class="st7" d="M52.2,181.5c-0.6,3-1.8,5.8-3.4,8.3"/>
          <path data-ignore class="st7" d="M41.1,154.7c-2.5-1.6-5.3-2.8-8.3-3.4"/>
          <path data-ignore class="st7" d="M22,151.2c0.6,2.4,2.8,4.2,5.4,4.2s4.8-1.8,5.4-4.2"/>
          <path data-ignore class="st7" d="M41.1,197.4c-0.5-0.8-0.8-1.8-0.8-2.9c0-3.1,2.5-5.6,5.6-5.6c1.1,0,2,0.3,2.9,0.8"/>
          <path data-ignore class="st7" d="M13.7,197.4c0.5-0.8,0.8-1.8,0.8-2.9c0-3.1-2.5-5.6-5.6-5.6c-1,0-2,0.3-2.9,0.8"/>
          <path data-ignore class="st7" d="M41.1,154.7c-0.5,0.8-0.8,1.8-0.8,2.9c0,3.1,2.5,5.6,5.6,5.6c1.1,0,2-0.3,2.9-0.8"/>
          <path data-ignore class="st7" d="M13.7,154.7c0.5,0.8,0.8,1.8,0.8,2.8c0,3.1-2.5,5.6-5.6,5.6c-1,0-2-0.3-2.9-0.8"/>
          <path data-ignore class="st7" d="M22,200.8c0.6-2.4,2.8-4.2,5.4-4.2s4.8,1.8,5.4,4.2"/>
          <path data-ignore class="st7" d="M2.6,181.5c2.4-0.6,4.2-2.8,4.2-5.4c0-2.6-1.8-4.8-4.2-5.4"/>
          <path data-ignore class="st7" d="M52.2,181.5c-2.4-0.6-4.2-2.8-4.2-5.4c0-2.6,1.8-4.8,4.2-5.4"/>
        </g>
        <line data-ignore class="st7" x1="81.5" y1="141.1" x2="81.5" y2="150.4"/>
        <line data-ignore class="st7" x1="64.4" y1="141.1" x2="64.4" y2="188.9"/>
        <path data-ignore class="st7" d="M70,194.5c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6"/>
        <path data-ignore class="st7" d="M33,176.2c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6"/>
        <path data-ignore class="st7" d="M87.1,156c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6"/>
        <line data-ignore class="st7" x1="64.4" y1="200.1" x2="64.4" y2="211.1"/>
        <line data-ignore class="st7" x1="81.5" y1="161.7" x2="81.5" y2="211.1"/>
      </g>
    </g>
    <g>
      <text data-ignore transform="matrix(1 0 0 1 194.3394 106.3896)" class="st1 st2 st3">RESEARCH</text>
      <g>
        <path data-ignore class="st6" d="M239.7,41.1L239.7,41.1c2.1-3.7,3.3-8,3.3-12.6c0-8.9-4.5-16.8-11.4-21.3c-4.1-2.8-9-4.3-14.3-4.3
          c-3.5,0-6.9,0.7-9.9,2c-6.2,2.6-11.2,7.5-13.8,13.8c-1.3,3.1-2,6.4-2,10c0,5.3,1.6,10.2,4.3,14.3c4.6,6.9,12.5,11.4,21.4,11.4
          c4.6,0,8.9-1.2,12.6-3.3L248.1,69c4.1-2.3,7.4-5.7,9.8-9.7L239.7,41.1z M223.4,44.3c-1.2,0.5-2.4,0.8-3.7,1
          c-0.8,0.1-1.5,0.2-2.3,0.2c-4.1,0-7.9-1.5-10.8-3.9c-0.8-0.7-1.6-1.4-2.2-2.2c-0.7-0.9-1.4-1.8-1.9-2.9c-1.2-2.3-2-5-2-7.9
          c0-9.4,7.6-16.9,16.9-16.9c2.9,0,5.6,0.7,7.9,2c5.4,2.8,9,8.5,9,15c0,0.8-0.1,1.6-0.2,2.4c-0.2,1.3-0.5,2.5-1,3.7
          C231.4,39,227.9,42.6,223.4,44.3z"/>
        <path data-ignore class="st4" d="M234.3,28.5c0,9.3-7.6,16.9-16.9,16.9c-9.4,0-16.9-7.6-16.9-16.9c0-9.4,7.6-16.9,16.9-16.9
          C226.7,11.6,234.3,19.1,234.3,28.5z"/>
        <g>
          <path data-ignore class="st6" d="M264.9,66.4c-2.3,4.1-5.7,7.5-9.8,9.8l-7.1-7.1c2.2-1.3,4.2-2.8,6-4.7c1.5-1.5,2.7-3.2,3.8-5.1L264.9,66.4z"
            />
          <path data-ignore class="st7" d="M229.9,50.8c-3.7,2.1-8,3.3-12.6,3.3c-14.2,0-25.7-11.5-25.7-25.7c0-14.2,11.5-25.7,25.7-25.7
            c14.2,0,25.7,11.5,25.7,25.7c0,4.6-1.2,8.9-3.3,12.6"/>
          <path data-ignore class="st7" d="M229.9,50.8L248.1,69c0,0,7.1,7.1,7.1,7.1c4.1-2.3,7.5-5.7,9.8-9.8c0,0-7.1-7.1-7.1-7.1l-18.2-18.2"/>
          <path data-ignore class="st7" d="M234.2,28.5c0,9.4-7.6,16.9-16.9,16.9c-9.3,0-16.9-7.6-16.9-16.9c0-9.4,7.6-16.9,16.9-16.9"/>
        </g>
      </g>
    </g>
    <path data-start="0" data-duration="36" class="st0" d="M228.2,131.3c57.6,0,104.2,46.7,104.2,104.2s-46.7,104.2-104.2,104.2S124,293.1,124,235.5"/>
    <line data-start="36" data-duration="7" class="st0" x1="139" y1="250.3" x2="124" y2="235.3"/>
    <line data-start="43" data-duration="7" class="st0" x1="124" y1="235.3" x2="109" y2="250.3"/>
  </svg>
</template>

<script>
import Vivus from 'vivus';

export default {
  name: 'ServicesGraphic',
  data () {
    return {
      locations: {},
      activeLocation: null,
    }
  },
  mounted: function() {
    new Vivus('Layer_1', { duration: 50, type: "scenario" }); // duration is in FRAMES, not milliseconds
  },
  methods: {
    getLocations() {
      this.$prismic.client.getSingle('locations')
        .then((locationsContent) => {
          this.locations = locationsContent.data.locations;
        })
    },
    filter (idx) {
      document.querySelectorAll('.location').forEach(function(location, index) {
        if (index == idx) {
          location.classList.add('active');
        } else {
          location.classList.remove('active');
        }
      });

      document.querySelectorAll('circle').forEach(function(marker, index) {
        if (index == idx) {
          marker.classList.add('active');
        } else {
          marker.classList.remove('active');
        }
      });
    }
  },
  created () {
    this.getLocations();
  }
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";
@import "../assets/sass/colors.scss";


.st0{fill:none;stroke:$teal;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
.st1{fill:#1B1D4C;}
.st2{font-family:'Open Sans'; letter-spacing: 1px; font-weight: 700;}
.st3{font-size:12px;}
.st4{fill:#96A8D6;}
.st5{fill:#FDE48D;}
.st6{fill:#C7D8E9;}
.st7{fill:none;stroke:#1B1D4C;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
.st8{font-size:11.6411px;}

svg {
  max-width: 600px;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
